import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LightningDataService {

  constructor(private http: HttpClient) { }

  getWindData(url){
    let dataPromise = new Promise((resolve,reject) => {
      this.http.get(url).subscribe(
        data=>{
          let obj = this.setWindData(data);
          resolve(obj);
        }
      )
    })
    return dataPromise;
  }

  getDefaultSourceFromSourceList(sourceList,forecastLength){
    for(let index in sourceList){
        let sourceInfo = sourceList[index];
        if(sourceInfo['forecastLengthList'].indexOf(forecastLength) > -1){
          return sourceInfo['source']
        }
    }
}

  getHeatMap(url){
    let dataPromise = new Promise((resolve,reject) =>{
      this.http.get(url).subscribe(
        data => {
          let obj = this.setMapData(data);
          resolve(obj);
      });
    });
  return dataPromise;
  }

  setMapData(data) {
    let obj = {};
    let imageUrl = {};
    let imageBounds = [];
    for (let block of Object.keys(data)) {
      for (let property of Object.keys(data[block])) {
        imageUrl = data[block]['heatMapImage'];
        let latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['southWest']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['southWest']['longitude']);
        imageBounds.push(latlongs);
        latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['northEast']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['northEast']['longitude']);
        imageBounds.push(latlongs);
      }
      obj['url'] = imageUrl;
      obj['bounds'] = imageBounds;
    }
    return obj;
  }

  setWindData(data) {
    for (let block of Object.keys(data)) {
      let array = [];
      let obj1 = new Object();
      obj1['header'] = {
        "parameterUnit": "m.s-1",
        "parameterNumber": 2,
        "dx": 0.5,
        'dy': 0.5,
        "parameterNumberName": "eastward_wind",
        "la1": 40.0,
        "la2": 5.0,
        'parameterCategory': 2,
        "lo2": 100.0,
        "nx": 71,
        "ny": 71,
        "refTime": "2017-02-01 23:00:00",
        "lo1": 65.0
      };
      obj1['data'] = data[block]['data1'];
      array[0] = obj1;

      let obj2 = {};
      obj2["header"] = {
        "parameterUnit": "m.s-1",
        "parameterNumber": 3,
        "dx": 0.5,
        "dy": 0.5,
        "parameterNumberName": "eastward_wind",
        "la1": 40.0,
        "la2": 5.0,
        "parameterCategory": 2,
        "lo2": 100.0,
        "nx": 71,
        "ny": 71,
        "refTime": "2017-02-01 23:00:00",
        "lo1": 65.0
      };
      obj2['data'] = data[block]['data2'];
      array[1] = obj2;
      return array;
    }
  }

  // getForecastFileTimeStamp(primarySource,secondarySource) {
  //   let url = ProjConstants.API_URL + ProjConstants.API_MAPPING['FORECASTFILES'] + '/' + primarySource + "/" + secondarySource;
  //   let promise = new Promise((resolve,reject)=> {
  //     this.http.get(url).subscribe(data=>{
  //       let max = data[primarySource];
  //       for(let source in data){
  //         if(max==undefined || Number(data[source]) > max){
  //          max = Number(data[source]) 
  //         }
  //       }
  //       resolve(max.toString())
  //     })
  //   }) 
  //   return promise
  // }

}
